import CdnImage from 'components/util/CdnImage'
// import CloudinaryImage from 'components/util/CloudinaryImage'
import { navigate } from 'gatsby'
import React from 'react'
import LinkButton, { LinkButtonProp } from '../common/button'
import './index.css'

interface Props {
  backgroundColor: string
  cloudinaryImageLeft: any
  builderImageLeft: any
  cloudinaryImageRight: any
  builderImageRight: any
  cloudinaryImageLeftAltText: string
  cloudinaryImageRightAltText: string
  heroFooterBackground: any
  heroFooterBackgroundMobile: any
  buttonProp: LinkButtonProp
  showButton: boolean
}

const HeroDoubleImage = ({
  backgroundColor,
  cloudinaryImageLeft,
  cloudinaryImageRight,
  builderImageLeft,
  builderImageRight,
  cloudinaryImageLeftAltText,
  cloudinaryImageRightAltText,
  heroFooterBackground,
  heroFooterBackgroundMobile,
  buttonProp,
  showButton
}: Props) => {
  return (
    <div
      className="bg-image-none relative h-full w-full bg-bottom bg-no-repeat md:bg-cover -mt-6 lg:-mt-12"
      style={{ backgroundColor }}
    >
      <main className="mx-auto flex h-full w-full flex-col 2xl:container pb-2">
        <div className="flex flex-row mx-auto mt-8 h-full max-h-[1000px] min-h-[11rem] lg:min-h-[24rem] w-full lg:w-10/12 justify-center pt-6 mb-6 lg:mb-0">
          <div className="w-2/5 mx-auto">
            {' '}
            <CdnImage
              className="index-2 h-full relative w-full rounded-2xl object-cover"
              url={builderImageLeft}
              alt={cloudinaryImageLeftAltText}
              lazyLoad={false}
              steps={[572]}
              width={'500'}
            />
            {/* {builderImageLeft ? (
              <CdnImage
                className="index-2 h-full relative w-full rounded-2xl object-cover"
                url={builderImageLeft}
                alt={cloudinaryImageLeftAltText}
                lazyLoad={false}
                steps={[572]}
                width={'500'}
              />
            ) : (
              <CloudinaryImage
                className="index-2 h-full relative w-full rounded-2xl object-cover"
                publicId={cloudinaryImageLeft?.public_id}
                alt={cloudinaryImageLeftAltText}
                loading={'eager'}
                steps={[572]}
                width={500}
              />
            )} */}
          </div>
          <div className="w-2/5 mx-auto">
            {' '}
            <CdnImage
              className="index-2 h-full relative w-full rounded-2xl object-cover"
              url={builderImageRight}
              alt={cloudinaryImageRightAltText}
              lazyLoad={false}
              steps={[572]}
              width={'500'}
            />
            {/* {builderImageRight ? (
              <CdnImage
                className="index-2 h-full relative w-full rounded-2xl object-cover"
                url={builderImageRight}
                alt={cloudinaryImageRightAltText}
                lazyLoad={false}
                steps={[572]}
                width={'500'}
              />
            ) : (
              <CloudinaryImage
                className="index-2 h-full relative w-full rounded-2xl object-cover"
                publicId={cloudinaryImageRight?.public_id}
                alt={cloudinaryImageRightAltText}
                loading={'eager'}
                steps={[572]}
                width={500}
              />
            )} */}
          </div>
        </div>
        {showButton && (
          <button
            className={`mx-auto flex w-10/12 items-center justify-center rounded-full border border-transparent bg-[#006685] px-5 py-3 text-base font-medium text-[#FFFFFF] md:mt-8 md:text-lg lg:my-8 lg:w-2/5`}
            onClick={() => {
              if (typeof window.gtag !== 'undefined') {
                window.gtag('event', 'cta_component_dog_hero_cta_submit_logged_in', {
                  page: 'home_page'
                })
              }

              navigate(`${buttonProp?.buttonUrl}`)
            }}
          >
            {buttonProp?.loggedInButtonText}
          </button>
        )}
      </main>
      <div
        className="font-sans-serif relative hidden md:block h-20 w-full bg-cover bg-top bg-no-repeat text-center text-base 2xl:mx-auto 2xl:h-28"
        style={{ backgroundColor, backgroundImage: heroFooterBackground ? `url(${heroFooterBackground})` : 'none' }}
      ></div>
      <div
        className="font-sans-serif relative block md:hidden h-12 w-full bg-cover bg-top bg-no-repeat text-center text-base 2xl:mx-auto 2xl:h-28 "
        style={{
          backgroundColor,
          backgroundImage: heroFooterBackgroundMobile ? `url(${heroFooterBackgroundMobile})` : 'none'
        }}
      ></div>
    </div>
  )
}

export default HeroDoubleImage
